export interface StatusInfo {
  label: string;
  color: string;
}

interface GetStatusInfoParams {
  status: string;
  cancellationCategory?: string | null;
  isPast?: boolean;
}

export const getReservationStatusInfo = ({
  status,
  cancellationCategory,
  isPast = false,
}: GetStatusInfoParams): StatusInfo => {
  const statusColors: Record<string, string> = {
    PENDING: "#ffaf5b",
    CONFIRMED: "#20c24a",
    CANCELLED: "#b6442e",
    CANCELLED_NO_REFUND: "#b6442e",
    CHANGE_REQUESTED_BY_ADMIN: "#d3d380",
    PREFERENCE_OVERRIDE_REQUESTED: "#d3d380",
  };

  const statusLabels: Record<string, string> = {
    PENDING: "큐레이션 중",
    CONFIRMED: isPast ? "완료" : "초대 확정",
    CANCELLED: "예약 취소",
    CANCELLED_NO_REFUND: "예약 취소",
    CHANGE_REQUESTED_BY_ADMIN: "변경 제안",
    PREFERENCE_OVERRIDE_REQUESTED: "일정 변경 제안",
  };

  let label = statusLabels[status] || status;

  // Enhance label for cancelled reservations based on category
  if ((status === "CANCELLED" || status === "CANCELLED_NO_REFUND") && cancellationCategory) {
    switch (cancellationCategory) {
      case "USER_DECLINED_CHANGE":
        label = "예약 취소 (변경 거절)";
        break;
      case "ADMIN_CANCELLED":
        label = "예약 취소 (관리자)";
        break;
      case "EVENT_EXPIRED":
        label = "예약 취소 (만료)";
        break;
      case "USER_REQUESTED":
        // Keep default "예약 취소" label
        break;
    }
  }

  const color = statusColors[status] || "#20c24a";

  return { label, color };
};
